<template>
  <div
    v-if="currentAccount"
    class="row roomy"
  >
    <div class="margin-auto margin-bottom-4xl laptop:margin-right-0 laptop:margin-bottom-0">
      <commission-card
        :cost="3000"
        :icon-count="1"
        :theme="theme"
        avatar="faStar"
        description="Make your brand's existing logo known and accessible to millions of users by adding it to Font Awesome Free."
        type="logo"
      >
        <footer
          slot="footer"
          class="section text-left"
        >
          <dl class="padding-0 margin-0 size-sm">
            <dt>Order ID:</dt>
            <dd>{{ currentOrder.number }}</dd>

            <dt class="sr-only">Email associated with subscription</dt>
            <dd>{{ currentAccount.email }}</dd>
          </dl>
        </footer>
      </commission-card>
    </div>

    <div class="column-12 laptop:column laptop:margin-left-4xl">
      <div class="margin-bottom-4xl">
        <h1 class="margin-top-0 laptop:margin-bottom-md">{{ selectedSalutation }}</h1>
        <p class="size-lg line-length-md">You've commissioned your logo to be added to Font Awesome's brands icons</p>
      </div>

      <ol style="--list-style-type: none; --padding-left: 0">
        <success-next-step
          title="We'll Be In Touch About Next Steps"
          icon-name="faHandshake"
        >
          <p>
            We'll reach out to you via email shortly. We'll ask you for some details about your brand and for logo assets as well. Once we have your logo
            coverted into an icon, you'll be able to check it out before we ship it. If you have any questions about the processing,
            <a href="mailto:icons@fontawesome.com?subject=I added my logo and have a question">get in touch</a>
            .
          </p>
        </success-next-step>

        <success-next-step
          title="Your logo will a part of Font Awesome!"
          icon-name="faRocketLaunch"
        >
          <p>Your logo will be added to Font Awesome. It will be bundled into our brand icons collection for all Font Awesome users to have access to.</p>
        </success-next-step>
      </ol>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import sample from 'lodash/sample'
  import CommissionCard from '../components/CommissionCard'
  import SuccessNextStep from 'app/views/buy/components/SuccessNextStep'

  export default {
    name: 'CommissionLogoSuccess',

    components: {
      CommissionCard,
      SuccessNextStep
    },

    props: {
      theme: {
        type: String,
        default: 'purple'
      }
    },

    computed: {
      ...mapGetters('orders', ['currentOrder']),

      ...mapGetters('accounts', ['currentAccount']),

      selectedSalutation() {
        const options = ['Great Success!', 'Somehow You Got Even More Awesome!', 'Font-Freaking-Tastic!']

        return sample(options)
      }
    }
  }
</script>
